import styled from '@emotion/styled';

const AlbumArtContainer = styled('div')({
  height: '6rem',
  position: 'relative',
  width: '6rem',
});

export default AlbumArtContainer;
